<template>
    <div class="update-qwilr-field">
      <h3>{{ this.formTitle }}</h3>
      <div class="form-group mb-4">
        <label for="qwilr-field-name" class="form-label">Field Name</label>
        <input
          type="text"
          id="qwilr-field-name"
          class="form-control"
          v-model="fieldName"
      />
      </div>
      <div class="form-group mb-4" v-if="this.isKey">
        <label for="name" class="form-label">Type</label>
        <select 
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedFieldTypeId" @change="fieldTypeSelected"
            >
            <option value="">Select a field type</option>
            <option 
                v-for="(type, index) in fieldTypes" 
                :key="index" 
                :value="type.id"
            >
            {{ type.name }}
            </option>
        </select>
      </div>
      <div v-if="selectedFieldTypeId==2">
        <div class="form-group mb-4">
          <label for="data-source" class="form-label">Data Source</label>
          <select 
            id="data-source"
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedDataSourceId"
            >
            <option value="">Select a data source</option>
            <option 
                v-for="(dataSource, index) in qwilrDataSources" 
                :key="index" 
                :value="dataSource.id"
            >
            {{ dataSource.dataSourceName }}
            </option>
          </select>
        </div>
        <div class="form-group mb-4">
            <label for="query" class="form-label">Query</label>
            <input
                type="text"
                id="query"
                class="form-control"
                placeholder="Enter query"
                v-model="query"
            />
        </div>
        <div class="form-group mb-4">
            <label for="column-id" class="form-label">Column Id</label>
            <input
                type="text"
                id="column-id"
                class="form-control"
                placeholder="Enter column id"
                v-model="columnId"
            />
        </div>
        <div class="form-group mb-4">
            <label for="column-value" class="form-label">Column Value</label>
            <input
                type="text"
                id="column-value"
                class="form-control"
                placeholder="Enter column value"
                v-model="columnValue"
            />
        </div>
      </div>
      <div class="form-group mb-4">
        <label for="qwilr-field-description" class="form-label">Field Description</label>
        <input
          type="text"
          id="qwilr-field-description"
          class="form-control"
          v-model="description"
          placeholder="Enter field description"
      />
      </div>
      
      <div class="form-buttons">
        <button class="btn btn-primary" @click="updateField" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Update Field
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrDefinitionField, GetQwilrDataSources } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { FieldType} from "@/core/constant/QueryFieldType";

  export default{
    name:"UpdateQwilrDefinitionField",
    props:{
        field:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            description:'',
            fieldId:'',
            fieldName:'',
            formTitle:'',
            fieldTypes:[
                {id:FieldType.Text, name:'Text'},
                {id:FieldType.Query, name:'Query'}
            ],
            selectedFieldTypeId:1,
            formHeight:500,
            query:'', 
            columnId:'', 
            columnValue:'',
            isKey:false,
            isBusy:false,
            qwilrDataSources:[],
            selectedDataSourceId:null
        }
    },
    methods:{
        async updateField(){
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.validateFields()){
                this.isBusy = false;
                return;
              } 

              if(!this.isKey){
                this.selectedFieldTypeId=FieldType.NotAKey
              }

              if(this.selectedFieldTypeId==FieldType.Query){
                this.query=this.query.trim()
                this.columnId=this.columnId.trim()
                this.columnValue=this.columnValue.trim()
              }
            
              const toast = useToast();
              const payload = 
              { 
                id:this.field.id, 
                field:this.fieldName, 
                description:this.description,
                fieldType:this.selectedFieldTypeId,
                query:this.query,
                columnId:this.columnId,
                columnValue:this.columnValue,
                qwilrDataSourceId:this.selectedDataSourceId
              };
          
              await UpdateQwilrDefinitionField(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Field updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('fieldUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update field : ${errorMessage}`, {timeout: 2000,});
                      })
            }, 500);
        },
        validateFields() {
          const toast = useToast();

          if (this.fieldName.trim() === '') {
            toast.error('Field name is required!', { timeout: 3000 });
            return false; 
          }

          if(this.isKey){
            if(!this.selectedFieldTypeId){
              toast.error('Field type is required!', { timeout: 3000 });
                  return false; 
            }

            if (this.fieldName.trim().replace(/@/g, '') === '') {
              toast.error('Field name is required!', { timeout: 3000 });
              return false; 
            }
          }

          if(this.selectedFieldTypeId==FieldType.Query){
            if(this.selectedDataSourceId<=0 || this.selectedDataSourceId==null){
                toast.error('Data source is required!', { timeout: 3000 });
                return false; 
            }
            if (this.query.trim() === '') {
                toast.error('Query is required!', { timeout: 3000 });
                return false; 
            }
            if (this.columnId.trim() === '') {
                toast.error('Column Id is required!', { timeout: 3000 });
                return false; 
            }
            if (this.columnValue.trim() === '') {
                toast.error('Column Value is required!', { timeout: 3000 });
                return false; 
            }
            
          }

          if(this.isKey){
            let isValid = /^@\w+$/.test(this.fieldName.trim());
            if(!isValid){
                toast.error('Field name should start with one @ symbol', { timeout: 3000 });
                return false; 
            }
          }
          
          return true; 
        },
        async fetchQwilrDataSources() {
          let data = await GetQwilrDataSources();
          if(data)
          {
            this.qwilrDataSources = data.qwilrDataSources;
          }
        }
    },
    created() {
        this.fieldId = this.field.id
        this.fieldName=this.field.field
        this.description=this.field.description
        this.formTitle = this.field.isKey ? 'Update Key Field' : 'Update Content Field';
        this.selectedFieldTypeId = this.field.fieldType;
        if(this.field.fieldType==FieldType.Query){
            this.query=this.field.query
            this.columnId=this.field.columnId
            this.columnValue=this.field.columnValue
            this.selectedDataSourceId=this.field.qwilrDataSourceId
        }
        this.isKey=this.field.isKey
        this.fetchQwilrDataSources();
    }
  }
 </script>
  
  <style scoped>
  .update-qwilr-field {
    width: 600px;
    height: var(--form-height);
    padding: 40px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  